/*
* Community Hub From Submit via Ajax
*/
var formCommunityHubSubmit;

(function() {
    window.formCommunityHubSubmit = function() {
        var form = document.querySelector('#community-form');
        var formValues = new URLSearchParams(new FormData(form)).toString();
        var xhr = new XMLHttpRequest();
        xhr.open('POST', window.location.origin + '/wp-content/themes/asbestos/ajax/community-form.php');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function() {
            if (xhr.status === 200) {
                form.querySelector('.c-form__inner').style.display = 'none';
                form.querySelector('.c-form__heading').textContent = 'Thank You';
                var message = document.createElement('p');
                message.innerHTML = 'We have received your request. A member of our team will reach out to you shortly to discuss how we can collaborate together. You can email our editor, Walter Pacheco, directly at <a href="mailto:wpacheco@asbestos.com">wpacheco@asbestos.com</a>';
                form.querySelector('.c-form__heading').insertAdjacentElement('afterend', message);
            }
        };
        xhr.send(formValues);
        return false;
    };
})();
